'use client';

import { useId } from 'react';
import type { CSSProperties } from 'react';
import {
  RiCodeSSlashLine,
  RiFileDownloadLine,
  RiLayoutGridLine,
  RiStackLine,
} from '@remixicon/react';
import { useTranslations } from 'next-intl';

import { ProductSection, SectionHead } from '@/components/product-section';
import { hl } from '@/lib/rich-text';

/**
 * "Tek tablo" — kampanyalar ekranının kendisi ve dışarıya açılan kapılar.
 *
 * Doğrulanmış olgular (14 Eki 2026 ürün dökümü): birleşik çok platformlu
 * tablo + karşılaştırma; toplu durdur/sürdür (100 kampanyaya kadar);
 * CSV/PDF dışa aktarım (`campaign-export.tsx`); geliştirici API (52 uç) ve
 * MCP (39 araç), `mvk_live_` anahtarı OKUMA/YAZMA kapsamıyla. Sayılar
 * `@mentorivo/shared/developer-api`ten; değişirse burası da değişir.
 */

const FACTS = [
  { key: 'table', Icon: RiLayoutGridLine },
  { key: 'bulk', Icon: RiStackLine },
  { key: 'export', Icon: RiFileDownloadLine },
  { key: 'api', Icon: RiCodeSSlashLine },
] as const;

export function CampaignOps() {
  const t = useTranslations('featuresCampaigns.ops');
  const uid = useId();

  return (
    <ProductSection tone="white" labelledBy={`${uid}-title`}>
      <SectionHead
        id={`${uid}-title`}
        eyebrow={t('eyebrow')}
        title={t.rich('title', { hl })}
        lead={t('lead')}
      />

      <ul className="ps-facts" style={{ '--ps-facts': 4 } as CSSProperties}>
        {FACTS.map(({ key, Icon }) => (
          <li key={key} className="ps-fact">
            <Icon className="ps-fact-icon" size={20} aria-hidden="true" />
            <p className="ps-fact-title">{t(`items.${key}.title`)}</p>
            <p className="ps-fact-text">{t(`items.${key}.text`)}</p>
          </li>
        ))}
      </ul>
    </ProductSection>
  );
}
